import React, { Component } from "react";
import {Route, Switch} from "react-router-dom";
import { getRoutes, protectedRoutes, routes } from "../../routes";
import "./Base.css";
import Header from "../../components/header/Header";
import LeftMenu from "../../components/leftmenu/LeftMenu";

// Redux
import withShipment from "../../withShipment";
import {userInfoSelector, isAuthenticatedSelector} from "../../redux/selectors/auth";
import {authLogout} from "../../redux/actions/auth";
import { ROUTE_TYPE } from "../../routes/constants";
import Login from "../Login/Login";
import { showingMenuItemsSelector } from "../../redux/selectors/global";
import PropTypes from "prop-types";
import Slide from "@material-ui/core/Slide";
import DashboardFinal from "../../components/dashboard/Dashboard";

class Base extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: window.matchMedia('(max-width: 800px)').matches,
    };
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated) {
    }
  }

  componentDidMount() {
    if(this.props.isAuthenticated){

    }

  }


  protectRoutes = () => {
    const userRoutes = this.props.userInfo.routes ? [...this.props.userInfo.routes] : []
    return getRoutes().filter(route => userRoutes.includes(route.id)).concat(routes)
  }

  leftMenuRoutes = () => {
    let displayedRoutes = [];
    const userRoutes = this.props.userInfo.routes ? [...this.props.userInfo.routes] : [];
    let dividerCount = 0;

    protectedRoutes.forEach(route => {
      if (route.type === ROUTE_TYPE.DIVIDER) {
        if (dividerCount === 0) {
          displayedRoutes = [...displayedRoutes, route];
          dividerCount++;
        }
      } else if (userRoutes.includes(route.id)) {
        displayedRoutes = [...displayedRoutes, route];
        dividerCount = 0;
      }
    });

    return displayedRoutes;
  };

  render() {
    return (
      <>
        <div className="custom-container-fluid">
          <div style={{ width: '100%' }}>
            {this.props.isAuthenticated && (
              <Header
                logout={this.props.authLogout}
                firstname={this.props.userInfo.firstname}
                userRoutes={[...this.props.userInfo.routes]}
                routes={this.leftMenuRoutes()}
              />
            )}


            <div className="custom-container-fluid">
              <div
                className="leftContainer"
                style={{ backgroundColor: '#000c36', color: 'white' }}
              >
                {this.props.isAuthenticated && window.screen.width > 800 && (
                  <Slide
                    direction="right"
                    in={this.props.showingMenuItems}
                    mountOnEnter
                    unmountOnExit
                  >
                    <LeftMenu
                      logout={this.props.authLogout}
                      routes={this.leftMenuRoutes()}
                      userRoutes={[...this.props.userInfo.routes]}
                      isDrawer={false}
                    />
                  </Slide>
                )}
              </div>

              <div
                className={
                  this.props.showingMenuItems && !this.state.isMobile && this.props.isAuthenticated
                    ? 'rightContainer'
                    : 'fullWidthContainer'
                }
              >
                <Switch>
                  {this.protectRoutes().map((route) => (
                    <Route
                      key={route.id}
                      component={route.component}
                      path={route.path}
                    />
                  ))}

                  <Route key='base' component={this.props.isAuthenticated ? DashboardFinal : Login} path='/' exact />


                </Switch>
              </div>
            </div>
          </div>

        </div>

        {/*<Footer />*/}

      </>
    );
  }
}

Base.propTypes = {
  userInfo: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  showingMenuItems: PropTypes.bool,
};

Base.defaultProps = {
  userInfo: {},
  isAuthenticated: false,
  showingMenuItems: false,
};

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  isAuthenticated: isAuthenticatedSelector(state),
  showingMenuItems: showingMenuItemsSelector(state),
});

const actionCreators = {
  authLogout,
};

export default withShipment(
    {
      mapStateToProps,
      actionCreators,
    },
    Base
);
